export default {
  online_payments_off:
    'Levering er slået til, men kunder kan ikke bestille det: kurerlevering betales kun online, og onlinebetalinger er slået fra.',
  gateway_not_verified:
    'Levering er slået til, men kunder kan ikke bestille det: kurerlevering betales kun online, og onlinebetalinger er sat på pause, indtil din betalingskonto er bekræftet.',
  stripe_processing_fee_missing:
    'Levering er slået til, men kunder kan ikke bestille det: leveringsbud betales kun online, og onlinebetalinger er sat på pause, indtil din partner har fastsat sit behandlingsgebyr.',
  turn_on_online_payments: 'Slå onlinebetalinger til',
};
